exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-bar-element {\n    margin-right: 20px;\n    font-size: 0.65em;\n}\n\n.mat-toolbar {\n    background-color: black;\n    color: white;\n    background: -webkit-gradient(linear, left top, left bottom, from(#3a3a3a),to(#2f2f2f));\n    background: linear-gradient(to bottom, #3a3a3a 0%,#2f2f2f 100%);\n    border-bottom: 1px solid #404040;\n    -webkit-box-shadow: 0 0 2px black;\n            box-shadow: 0 0 2px black;\n    height: 48px;\n}\n\n.market-opening {\n    font-size: 0.65em;\n    position: absolute;\n    right: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/summary-bar/summary-bar.component.css
// module id = ../../../../../src/app/components/summary-bar/summary-bar.component.css
// module chunks = main